import { useEffect } from 'react';
import { useAgent } from '@livekit/components-react';
import { toastAlert } from '@/components/livekit/alert-toast';
import { useConnection } from './useConnection';

export function useAgentErrors() {
  const agent = useAgent();
  const { isConnectionActive, startDisconnectTransition, startReconnectTransition } = useConnection();

  useEffect(() => {
    if (isConnectionActive && agent.state === 'failed') {
      const reasons = agent.failureReasons;
      const shouldRetry = reasons.some((reason) =>
        reason.toLowerCase().includes('agent did not join')
      );

      toastAlert({
        title: shouldRetry ? 'Session ended — retrying…' : 'Session ended',
        description: (
          <>
            {reasons.length > 1 && (
              <ul className="list-inside list-disc">
                {reasons.map((reason) => (
                  <li key={reason}>{reason}</li>
                ))}
              </ul>
            )}
            {reasons.length === 1 && <p className="w-full">{reasons[0]}</p>}
            {shouldRetry && (
              <p className="w-full text-sm text-muted-foreground">
                Agent boot can take a moment. We&apos;ll try reconnecting automatically.
              </p>
            )}
            <p className="w-full">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://docs.livekit.io/agents/start/voice-ai/"
                className="whitespace-nowrap underline"
              >
                See quickstart guide
              </a>
              .
            </p>
          </>
        ),
      });

      if (shouldRetry) {
        const scheduled = startReconnectTransition();
        if (!scheduled) {
          startDisconnectTransition();
        }
      } else {
        startDisconnectTransition();
      }
    }
  }, [agent, isConnectionActive, startDisconnectTransition, startReconnectTransition]);
}
